<template>
  <div>
    <b-table-simple hover  responsive>
      <!-- HEADER -->
      <b-thead>
        <b-tr>
          <b-th>Wettbewerb</b-th>
          <b-th>angemeldete Kinder</b-th>
          <b-th>tatsächlich teilgenommen</b-th>
          <b-th>Teilnahmegebühren</b-th>
          <b-th>Saldo</b-th>
          <b-th></b-th>
        </b-tr>
      </b-thead>

      <!-- FOOTER -->
      <b-tfoot v-if="!showAll">
        <b-tr>
          <b-td colspan=6 class="text-center">
            <span v-on:click="showAll = true" style="cursor: pointer">ältere Wettbewerbe...</span>
          </b-td>
        </b-tr>
      </b-tfoot>

      <!-- BODY -->
      <b-tbody>
        <b-tr v-for="row in visibleCompetitions" :key="row.competition.id">

          <!-- title -->
          <b-td>
            <b-button :to="row.route" variant="primary" size="sm" class="w-100">
              {{ row.competition.title() }}
            </b-button>
          </b-td>

          <!-- registration count -->
          <b-td class="text-center">
            <span v-if="row.registration.registered()" v-b-tooltip.hover :title="row.registration.registrationCount + ' Schüler sind angemeldet'">
              {{ row.registration.registrationCount }}
            </span>
          </b-td>

          <!-- participated -->
          <b-td class="text-center">
            <span v-if="row.registration.registered()">{{ row.registration.prices }}</span>
            <span v-else>-</span>
          </b-td>

          <!-- total -->
          <b-td>
            <span v-if="row.registration.registered()" v-b-tooltip.hover :title="'Anz. Teilnehmer x ' + row.competition.costs.short">
              {{ row.registration.payment.total.short }}
            </span>
            <span v-else>-</span>
          </b-td>

          <!--  due -->
          <b-td>
            <span v-if="row.registration.registered() && row.payment.saldo.float < 0" v-b-tooltip.hover style="color: red" :title="'Bereits gezahlt: ' + row.payment.payed.short">{{ row.payment.saldo.short }}</span>
            <span v-else-if="row.registration.registered()" v-b-tooltip.hover :title="'Bereits gezahlt: ' + row.payment.payed.short">0 EUR</span>
            <span v-else>-</span>
          </b-td>

          <!-- bank button -->
          <b-td>
            <bank-details v-if="row.registration.registered() && row.registration.payment.saldo.float < 0" v-bind:school="school"></bank-details>
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>
<script>
import { RegistrationButton, BankDetails } from '@/components/competitions/registration'

export default {
  name: 'EndedCompetitionsTable',
  props: ['school', 'competitions'],
  components: {
    registrationButton: RegistrationButton,
    bankDetails: BankDetails
  },
  data: function () {
    return {
      showAll: false,
      defaultLimit: 3,
      fields: [
        {key: 'competition', label: 'Wettbewerb'},
        {key: 'registrations', label: 'angemeldete Kinder', class: 'text-center'},
        {key: 'participations', label: 'tatsächlich teilgenommen', class: 'text-center'},
        {key: 'total', label: 'Teilnahmegebühren', class: 'text-center'},
        {key: 'open', label: 'Saldo', class: 'text-center'},
        {key: 'button', label: '', class: 'text-right'}
      ]
    }
  },
  computed: {
    visibleCompetitions: function () {
      return this.showAll ? this.competitions : this.competitions.slice(0, this.defaultLimit)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/EndedTable.vue